import {
  downloadFile,
  ensureHttpPrefix,
  truncateText
} from "../../utils/utils.js";
import { FaCopy, FaPaperclip } from "react-icons/fa";
import "./FAQItem.css";
import { IFAQAll, IFAQFileAll } from "@/types/SPTypes.tsx";
import { useAppSelector } from "@/hooks/storeHooks.ts";
import { CREATE_NOTIFICATION } from "@/utils/enums.ts";
import { showNotification, TooltipComponent } from "fmv-component-ui-library";

const FAQItem = ({
  FAQ,
  FAQFiles
}: {
  FAQ: IFAQAll;
  FAQFiles?: IFAQFileAll[];
}) => {
  const isLoggedIn = useAppSelector(state => state.application.isLoggedIn);

  const FAQId = isLoggedIn ? FAQ.ID : FAQ.vsdlId;

  const handleCopyFAQ = () => {
    const urlWithHash = `${window.location.href}#faq-${FAQId}`;
    console.log("urlWithHash", urlWithHash);
    navigator.clipboard
      .writeText(urlWithHash)
      .then(() =>
        showNotification(CREATE_NOTIFICATION.SUCCESS, "", "Länk kopierad")
      )
      .catch(err => console.error("Error copying to clipboard", err));
  };

  const date = FAQ.verifiedDate ? new Date(FAQ.verifiedDate) : undefined;

  const formattedDate = date?.toLocaleDateString("sv-SE", {
    year: "numeric",
    month: "long",
    day: "numeric"
  });

  return (
    <div id={`faq-${FAQId}`} className="faq-card">
      <div className="faq-card-header">
        <TooltipComponent content="Kopiera länk" placement="top">
          <FaCopy className="faq-card-copy" onClick={handleCopyFAQ} />
        </TooltipComponent>
        <div>
          ID: {FAQId} &nbsp;–&nbsp; {FAQ.FAQTitle}
        </div>
      </div>

      <div className="faq-row faq-row-question">
        <div className="faq-row-label">Q.</div>
        <div className="faq-row-text">{FAQ.question}</div>
      </div>

      <div className="faq-row faq-row-answer">
        <div className="faq-row-label">A.</div>
        <div className="faq-row-text faq-row-answer-text">{FAQ.answer}</div>
        {FAQ.reference && (
          <p className="faq-reference">
            Hänvisning:&nbsp;
            <a
              href={ensureHttpPrefix(FAQ.reference)}
              target="_blank"
              rel="noopener noreferrer"
            >
              {truncateText(FAQ.reference, 70)}
            </a>
          </p>
        )}

        {/* show attached files if any */}
        {FAQFiles && FAQFiles.length > 0 && (
          <div className="faq-files">
            Bilagor:
            <ul>
              {FAQFiles.map(file => (
                <div
                  key={file.ID}
                  className="faq-file-row"
                  onClick={() => downloadFile(file, "FAQFiles")}
                >
                  <li>
                    {truncateText(file.Title, 70)} <FaPaperclip />
                  </li>
                </div>
              ))}
            </ul>
          </div>
        )}
        <div className="verified-container">
          <i>Verifierad: {formattedDate ?? "Datum saknas"}</i>
        </div>
      </div>
    </div>
  );
};

export default FAQItem;
